module.exports = __webpack_public_path__ + "image/index-right2.png";